import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Observable, EMPTY } from "rxjs";
import { catchError } from "rxjs/operators";
import {
  MzTabResult,
  MzTabResultControllerService
} from "../../../../modules/lipidcompass-backend-client";
import { LoggingService, LogLevel } from "../../_services/logging.service";
import { CommonModule } from "@angular/common";
import { DatasetCardComponent } from "../dataset-card/dataset-card.component";
import { ErrorCardComponent } from "../../errors/error-card/error-card.component";

enum IdTypeEnum {
  NATIVE_ID,
  ID,
  UNKNOWN
}

@Component({
  selector: "app-dataset-detail",
  templateUrl: "./dataset-detail.component.html",
  styleUrls: ["./dataset-detail.component.css"],
  standalone: true,
  imports: [CommonModule, DatasetCardComponent, ErrorCardComponent]
})
export class DatasetDetailComponent implements OnInit {
  private mzTabResultControllerService = inject(MzTabResultControllerService);
  private loggingService = inject(LoggingService);

  mzTabResult: Observable<MzTabResult> | undefined;
  errorMessage: string | null = null;
  private mzTabResultId: string | undefined;
  private idType: IdTypeEnum = IdTypeEnum.UNKNOWN;

  constructor() {
    const route = inject(ActivatedRoute);
    const translate = inject(TranslateService);

    translate.setDefaultLang("en");
    translate.use("en");
    this.loggingService.log(
      "DatasetDetailComponent",
      "Route snapshot parameters: " + JSON.stringify(route.snapshot.params),
      LogLevel.DEBUG
    );
    if (route.snapshot.params.id !== undefined) {
      this.mzTabResultId = route.snapshot.params.id;
      this.idType = IdTypeEnum.ID;
    } else if (route.snapshot.params.nativeId !== undefined) {
      this.mzTabResultId = route.snapshot.params.nativeId;
      this.idType = IdTypeEnum.NATIVE_ID;
    }
    this.loggingService.log(
      "DatasetDetailComponent",
      "mzTabResultId: " + this.mzTabResultId,
      LogLevel.DEBUG
    );
  }

  ngOnInit(): void {
    switch (this.idType) {
      case IdTypeEnum.ID:
        this.loggingService.log(
          "DatasetDetailComponent",
          "Retrieving mzTabResult by database id: " +
            this.mzTabResultId +
            " ...",
          LogLevel.DEBUG
        );
        if (this.mzTabResultId) {
          this.mzTabResult = this.mzTabResultControllerService
            .mzTabResultGetById(this.mzTabResultId)
            .pipe(
              catchError(err => {
                this.loggingService.log(
                  "DatasetDetailComponent",
                  "Error retrieving dataset by id: " + err,
                  LogLevel.ERROR
                );
                this.errorMessage =
                  "It appears the dataset you were trying to access is not yet public or does not exist. If you believe that this is an error, please contact us.";
                return EMPTY;
              })
            );
        }
        break;
      case IdTypeEnum.NATIVE_ID:
        this.loggingService.log(
          "DatasetDetailComponent",
          "Retrieving mzTabResult by native id: " + this.mzTabResultId + " ...",
          LogLevel.DEBUG
        );
        if (this.mzTabResultId) {
          this.mzTabResult = this.mzTabResultControllerService
            .mzTabResultGetByNativeId(this.mzTabResultId)
            .pipe(
              catchError(err => {
                this.loggingService.log(
                  "DatasetDetailComponent",
                  "Error retrieving dataset by native id: " + err,
                  LogLevel.ERROR
                );
                this.errorMessage =
                  "It appears the dataset you were trying to access is not yet public or does not exist. If you believe that this is an error, please contact us.";
                return EMPTY;
              })
            );
        }
        break;
      default:
        throw new Error("Unknown id type: " + this.idType);
    }
  }
}
